// extracted by mini-css-extract-plugin
export default {"zoomModal":"G3-z","image":"H3-z","button":"I3-z","isOverlayShown":"J3-z"};